import React from 'react'
import Table, { TableRow } from '../../../../../../common/components/molecule/Table/Table';
import { ConnectorType } from '../../../../types/stations.types';

export interface ConnectorItem {
    icon?: () => JSX.Element;
    name?: string;
    hardwareId?: string;
    tag: string
    onClick?: () => void;
    id: string;
    type?:  ConnectorType;
    hardwareIDRender: () => JSX.Element;
    ActionBtnRender?: () => JSX.Element;
    currency?: string;
    pricePerKwh?: number;
}

export interface ConnectorListViewProps {
    content : ConnectorItem[];
}

export default function ConnectorListView({content}: ConnectorListViewProps) {

    const contentFormated : TableRow[] = content.map((connector) => ({
        id: connector.id,
        data: [
            connector.icon ,
            connector.tag     || "N/A",
            connector.type   || "N/A",
            ((connector.pricePerKwh !== undefined)?connector.pricePerKwh :  "" ) + " " + (connector.currency || ""),
           connector.ActionBtnRender,

        ],
        onRowClick: connector.onClick
    })) || []
  return (
    <div>
      <Table headerTitle={["","Tag", "Type", "Prix par kWh" ]} bodyData={contentFormated} emptyMessage="Aucun connecteur trouvé"/>
    </div>
  )
}
